import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import type * as models from '../models'

/**
 * Executes toast action callbacks and dismisses toasts when configured.
 */
export const actionClicked = store.effects.create((feature: Feature) =>
  feature.actions.clickAction.observe().pipe(
    rxjs.withLatestFrom(feature.selectors.toasts.asObservable),
    rxjs.mergeMap(([action, toasts]) => {
      const toast = toasts.find(t => t.id === action.data.toastId)
      if (!toast) {
        return rxjs.EMPTY
      }

      const toastAction = toast.actions.find(
        ta => ta.id === action.data.actionId,
      )
      if (!toastAction) {
        return rxjs.EMPTY
      }

      const callbackParams: models.ActionCallbackParams = {
        actionId: toastAction.id,
        toastId: toast.id,
        value: toastAction.value,
      }

      const callback$ = rxjs
        .defer(() =>
          rxjs.from(
            Promise.resolve().then(async () =>
              toastAction.callback?.(callbackParams),
            ),
          ),
        )
        .pipe(
          rxjs.catchError(error => {
            console.error('Toast action callback failed', error)
            return rxjs.of(undefined)
          }),
          rxjs.ignoreElements(),
        )

      const dismiss$ = toastAction.closeOnClick
        ? rxjs.of(feature.actions.dismiss.from(action).create({ id: toast.id }))
        : rxjs.EMPTY

      return rxjs.merge(callback$, dismiss$)
    }),
  ),
)
